import * as React from "react";

const NISDownIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12.5002 6.12512C12.5002 6.31702 12.427 6.50902 12.2805 6.65527L8.53052 10.4053C8.23755 10.6982 7.76294 10.6982 7.46997 10.4053L3.71997 6.65527C3.427 6.36231 3.427 5.8877 3.71997 5.59473C4.01294 5.30176 4.48755 5.30176 4.78052 5.59473L8.00024 8.81457L11.2206 5.59426C11.5135 5.30129 11.9881 5.30129 12.2811 5.59426C12.4276 5.74074 12.5002 5.93293 12.5002 6.12512Z" fill="black" />
        </svg>
    );
};

export default React.memo(NISDownIcon);
